import { render, staticRenderFns } from "./ExpenseTable.vue?vue&type=template&id=770ebd40&"
import script from "./ExpenseTable.vue?vue&type=script&lang=js&"
export * from "./ExpenseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports